export { default as NumberInput, type NumberInputProps } from './NumberInput';
